export const SET_AUTH = 'SET_AUTH';
export const SET_CART = 'SET_CART';

export const REGISTRATION = 'REGISTRATION';
export const REGISTRATION_FAILED = 'REGISTRATION_FAILED';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';

export const LOGIN = 'LOGIN';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const REMOVE_ACCOUNT = 'REMOVE_ACCOUNT';
export const REMOVE_ACCOUNT_FAILED = 'REMOVE_ACCOUNT_FAILED';
export const REMOVE_ACCOUNT_SUCCESS = 'REMOVE_ACCOUNT_SUCCESS';

export const CLOTHES_INQUIRY = 'CLOTHES_INQUIRY';
export const CLOTHES_INQUIRY_FAILED = 'CLOTHES_INQUIRY_FAILED';
export const CLOTHES_INQUIRY_SUCCESS = 'CLOTHES_INQUIRY_SUCCESS';

export const CLOTHES_ENTITY = 'CLOTHES_ENTITY';
export const CLOTHES_ENTITY_FAILED = 'CLOTHES_ENTITY_FAILED';
export const CLOTHES_ENTITY_SUCCESS = 'CLOTHES_ENTITY_SUCCESS';

export const CLOTHES_INSERT = 'CLOTHES_INSERT';
export const CLOTHES_INSERT_FAILED = 'CLOTHES_INSERT_FAILED';
export const CLOTHES_INSERT_SUCCESS = 'CLOTHES_INSERT_SUCCESS';

export const CLOTHES_UPDATE = 'CLOTHES_UPDATE';
export const CLOTHES_UPDATE_FAILED = 'CLOTHES_UPDATE_FAILED';
export const CLOTHES_UPDATE_SUCCESS = 'CLOTHES_UPDATE_SUCCESS';

export const CLOTHES_DELETE = 'CLOTHES_DELETE';
export const CLOTHES_DELETE_FAILED = 'CLOTHES_DELETE_FAILED';
export const CLOTHES_DELETE_SUCCESS = 'CLOTHES_DELETE_SUCCESS';